export const container = "relative overflow-hidden";

export const list = `h-full flex gap-x-2 items-center overflow-auto no-scrollbar`;

const arrowContainer = `h-full hidden md:flex items-center w-16 absolute from-white via-white to-transparent`;
export const leftArrowContainer = `${arrowContainer} justify-start left-0 bg-gradient-to-r pl-1`;
export const rightArrowContainer = `${arrowContainer} justify-end right-0 bg-gradient-to-l pr-1`;
export const arrowIcon = `border-2 border-ll-placeholder text-ll-placeholder rounded-full w-8 h-8 bg-white cursor-pointer hover:scale-110 hover:shadow-md transition-all`;
